"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _CheckOutlined = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/CheckOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _CheckOutlined.default
  }));
};

/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNTggNS4zNWExIDEgMCAwMS4yNCAxLjRMMTMuMiAxNi4xYy0uNDMuNi0uNzggMS4xLTEuMSAxLjQ3LS4zMi4zOS0uNjguNzQtMS4xNC45Ni0uNzEuMzMtMS41LjQtMi4yNS4xNy0uNS0uMTUtLjktLjQ0LTEuMjgtLjc4LS4zNy0uMzMtLjc4LS43OC0xLjI3LTEuM2wtMS45LTIuMDRhMSAxIDAgMDExLjQ2LTEuMzdsMS44NyAyLjAxYy41My41Ny44OS45NSAxLjE4IDEuMjEuMjguMjYuNDMuMzMuNTEuMzYuMjcuMDguNTYuMDYuODItLjA3LjA4LS4wNC4yMi0uMTMuNDgtLjQ0LjI1LS4zLjU2LS43MyAxLjAxLTEuMzdsNi41OC05LjMyYTEgMSAwIDAxMS40LS4yNHoiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/React.forwardRef(CheckOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CheckOutlined';
}
var _default = exports.default = RefIcon;